export default function addExtrasTotalCost(formattedTotalCost, extrasList) {
  return extrasList.reduce((acc, { cost }) => {
    if (!cost) return acc;
    return acc + parseFloat(cost.replace(/\D/g, ''));
  }, parseFloat(formattedTotalCost)
  ).toFixed(2);
}